import { combineReducers } from "redux";

import shopCarReducer from "../pages/shopCar/module";

import userInfoReducer from './userInfoReducer'

import carInfoReducer from './carInfoReducer'
const reducer = combineReducers({
  shopCarReducer,
  userInfoReducer,
  carInfoReducer
});

export default reducer;
